export default (prop) =>
  ({ [prop]: a }, { [prop]: b }) =>
    a - b;
